import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.buttons = this.$('button')
    this.isScrolling = false
  }

  setActive(index) {
    this.buttons.forEach((button, i) => button.classList.toggle('is-active', i === index))
  }

  init() {
    this.onClick()
    this.onScroll()
  }

  onClick() {
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.isScrolling = true
        this.setActive(index)

        const { section } = button.dataset
        const target = document.querySelector(`[id="${section}"]`)

        gsap.to(
          window,
          {
            ease: 'power2.inOut',
            duration: 1,
            scrollTo: { y: target, offsetY: 120 },
            onComplete: () => {
              this.isScrolling = false
            },
          },
        )
      })
    })
  }

  onScroll() {
    this.buttons.forEach((button, index) => {
      const { section } = button.dataset
      const target = document.querySelector(`[id=${section}]`)

      gsap.to(target, {
        ease: 'power2.inOut',
        scrollTrigger: {
          trigger: target,
          start: 'top 50%',
          end: 'bottom 50%',
          onEnter: () => {
            if (this.isScrolling) return
            this.setActive(index)
          },
          onEnterBack: () => {
            if (this.isScrolling) return
            this.setActive(index)
          },
          onLeave: () => {
            if (this.isScrolling) return
            this.setActive(index)
          },
          onLeaveBack: () => {
            if (this.isScrolling) return
            this.setActive(index)
          },
        },
      })
    })
  }
}
